import { Box, Chip, Dropdown, IconButton, useNotificationCount, useTranslations } from "@bsm/component"
import { NotificationConfigButton, NotificationList, NotificationListToobar } from "@bsm/notification";
import { useState } from "react";

export const NotificationMenu = () => {

    const [
        NOTIFICATIONS
    ] = useTranslations(i18n)
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>();
    const notificationCount = useNotificationCount()

    return (
        <div>
            <div className="relative">
                <IconButton
                    icon={"fa-bell"}
                    className={"text-xl"}
                    onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
                        setAnchorEl(e.currentTarget)
                    }
                />
                {
                    notificationCount > 0 &&
                    <Chip className="py-0.5 px-2 absolute text-xs -top-0.5 right-0 bg-primary text-white" label={notificationCount?.toString()} />
                }
            </div>
            <Dropdown
                
                anchorEl={anchorEl}
                arrow
                placement="bottom-end"
                onClose={() => setAnchorEl(undefined)}
            >
                <Box 
                    className="w-[320px] box-transparent"
                    title={NOTIFICATIONS}
                    tools={
                        <NotificationConfigButton />
                    }>
                    <NotificationList isInNavbar />
                </Box>
            </Dropdown>
        </div>
    );
}

const i18n = [
    'Harea.Admin.LeftSideBar.Menu.General.Notifications.Label',
]